import React, { useEffect } from "react";
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";
import { history, store } from "../../../store/store";
import { hideNotification } from '../../../store/actions/notification';
import { Row, Col } from 'reactstrap';
import { Link } from 'react-router-dom';
import { ROUTE_DOCUMENTS } from "../../../config/routes";
import { PackageDetailsSection } from "./sections/PackageDetailsSection";
import { PackageDocumentsSection } from "./sections/PackageDocumentsSection";

function PackageDetailsComponent(props) {
  const { packageDetails} = props;

  useEffect( () => {
    return () => {
      store.dispatch(hideNotification());
    }
  }, []);

  return (
    <div className="package-detail-content">
      <PackageDetailsSection packageDetails={packageDetails}/>
      <hr className="my-4" />
      <PackageDocumentsSection packageDetails={packageDetails}/>
      <Row className="mt-2 text-right justify-content-md-end">
        <Col lg="auto mb-3 mb-xl-0">
          <Link
            className="btn btn-secondary"
            to={history.location.state && history.location.state.prevLocation !== null ? history.location.state.prevLocation : ROUTE_DOCUMENTS}
          >
            <FormattedMessage id="messages.go_back"/>
          </Link>
        </Col>
      </Row>
    </div>
  );
}

PackageDetailsComponent.defaultProps = {};

const PackageDetails = connect(null, {})(PackageDetailsComponent);

export { PackageDetails, PackageDetailsComponent };
